import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@ppl/ui';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';

/**
 * Provider / Participant PPL ID search for the correction lists. Emits the searchParam filters;
 * at least one ID is required so a search never pulls the whole list.
 */
@Component({
  selector: 'ppl-correction-line-filter',
  standalone: true,
  imports: [ButtonComponent, NgZorroModule, NzFormDirective, ReactiveFormsModule],
  templateUrl: './correction-line-filter.component.html',
  styleUrl: './correction-line-filter.component.css'
})
export class CorrectionLineFilterComponent implements OnInit {
  // TODO: confirm with the backend that the list pages search Participant PPL ID on this field.
  private readonly PARTICIPANT_PPL_ID_JSON_PATH = 'consumerId';

  /** searchParam field for Provider PPL ID; it differs between the correction list pages. */
  @Input() providerJsonPath = 'employerId';

  @Output() search = new EventEmitter<any[]>();
  @Output() clear = new EventEmitter<void>();

  filterForm!: FormGroup;
  showRequiredError = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      providerPplId: [null],
      participantPplId: [null],
    });
  }

  onSearch() {
    const providerPplId = this.filterForm.value.providerPplId?.trim();
    const participantPplId = this.filterForm.value.participantPplId?.trim();
    this.showRequiredError = !providerPplId && !participantPplId;
    if (this.showRequiredError) return;

    const filters = [];
    if (providerPplId) {
      filters.push({ jsonPath: this.providerJsonPath, value: providerPplId, operator: 'Equal' });
    }
    if (participantPplId) {
      filters.push({ jsonPath: this.PARTICIPANT_PPL_ID_JSON_PATH, value: participantPplId, operator: 'Equal' });
    }
    this.search.emit(filters);
  }

  onClear() {
    this.filterForm.reset();
    this.showRequiredError = false;
    this.clear.emit();
  }
}
